export default __webpack_public_path__ + "static/media/account.623272bc.svg";